import { render, staticRenderFns } from "./DetailsSalesLetterBox.vue?vue&type=template&id=25f18c80"
import script from "./DetailsSalesLetterBox.vue?vue&type=script&lang=ts"
export * from "./DetailsSalesLetterBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports